import React from "react";
import { Badge, Box, Text } from "@chakra-ui/react";
import { formatBRL } from "../../utils/formatters";
import { mensagemDeErro } from "../../utils/erroApi";

export const ACCENT = "#F68633";
export const VERDE = "#01695E";
export const VERMELHO = "#C53030";

// Preço é formado com margem de contribuição de 30%: ROAS abaixo de ~3,3x dá
// prejuízo por venda. O objetivo aprovado para as campanhas é 5x.
export const ROAS_EQUILIBRIO = 3.3;
export const ROAS_OBJETIVO_PADRAO = 5;

export const ESTRATEGIAS = {
  profitability: {
    label: "Rentabilidade",
    ajuda: "Mostra menos, para quem tem mais chance de comprar. Para anúncio que já vende bem.",
  },
  increase: {
    label: "Crescimento",
    ajuda: "Equilíbrio entre vender mais e aparecer mais.",
  },
  visibility: {
    label: "Visibilidade",
    ajuda: "Investe mais para aparecer para mais gente. Para anúncio novo.",
  },
};

export const STATUS_CAMPANHA = {
  active: { label: "Ativa", cor: "green" },
  paused: { label: "Pausada", cor: "yellow" },
  deleted: { label: "Excluída", cor: "gray" },
};

export const ACOES_HISTORICO = {
  entrar: { label: "Entrou", cor: "green" },
  sair: { label: "Saiu", cor: "red" },
  fixar_fora: { label: "Fixado fora", cor: "purple" },
  fixar_dentro: { label: "Fixado dentro", cor: "blue" },
  liberar: { label: "Devolvido à regra", cor: "gray" },
  campanha_criada: { label: "Campanha criada", cor: "orange" },
  campanha_editada: { label: "Campanha editada", cor: "orange" },
};

// Por que a regra deixou um anúncio de lado (códigos do backend).
export const MOTIVOS_IGNORADOS = {
  nao_atende: "não atendem a entrada",
  em_espera: "em espera (saíram por desempenho)",
  erro_recente: "com erro recente no ML",
  outra_campanha: "em outra campanha",
  outra_regra: "com regra de prioridade maior",
  manual: "postos à mão na campanha",
  fixado_fora: "fixados fora",
};

export const PERIODOS = [
  { label: "7 dias", dias: 7 },
  { label: "15 dias", dias: 15 },
  { label: "30 dias", dias: 30 },
  { label: "60 dias", dias: 60 },
  { label: "90 dias", dias: 90 },
];

export const isoDiasAtras = (dias) => {
  const d = new Date();
  d.setDate(d.getDate() - dias);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dia = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dia}`;
};

export const erroMsg = (e, padrao = "Falha na operação.") => mensagemDeErro(e?.response?.data ?? e, padrao);

export const num = (v, casas = 0) => {
  if (v === null || v === undefined || v === "" || Number.isNaN(Number(v))) return "—";
  return Number(v).toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas });
};

export const pct = (v, casas = 2) => (v === null || v === undefined ? "—" : `${num(v, casas)}%`);
export const roasTxt = (v) => (v === null || v === undefined ? "—" : `${num(v, 2)}x`);
export const brl = (v) => formatBRL(v);

export const corRoas = (roas) => {
  if (roas === null || roas === undefined) return "gray.500";
  if (roas >= ROAS_OBJETIVO_PADRAO) return "green.600";
  if (roas >= ROAS_EQUILIBRIO) return "orange.500";
  return "red.600";
};

export const dataBR = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return d && m ? `${d}/${m}${y ? `/${y}` : ""}` : "—";
};

export const dataHoraBR = (iso) => {
  if (!iso) return "—";
  const d = new Date(String(iso).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export function Kpi({ label, valor, ajuda, cor = VERDE }) {
  return (
    <Box bg="white" borderRadius="lg" boxShadow="sm" p={{ base: 3, md: 4 }} borderTop="3px solid" borderTopColor={cor} minW={0}>
      <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold" letterSpacing="wide" noOfLines={1}>
        {label}
      </Text>
      <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color={cor} lineHeight="1.2" mt={1} noOfLines={1}>
        {valor}
      </Text>
      {ajuda && <Text fontSize="xs" color="gray.500" mt={1} noOfLines={2}>{ajuda}</Text>}
    </Box>
  );
}

export function StatusCampanha({ status }) {
  const s = STATUS_CAMPANHA[status] || { label: status || "—", cor: "gray" };
  return <Badge colorScheme={s.cor} fontSize="0.7em">{s.label}</Badge>;
}

export function Vazio({ titulo, children }) {
  return (
    <Box textAlign="center" py={10} px={4} color="gray.500">
      <Text fontWeight="bold" color="gray.600" mb={1}>{titulo}</Text>
      {children && <Text fontSize="sm" maxW="520px" mx="auto">{children}</Text>}
    </Box>
  );
}
